import { FilterMetadata } from "redux/types";
import { CoLenderFinancier, CoLenderFinancierActionDispatch, CoLenderFinancierReduxTypes } from "./types";

export const fetchCoLenderFinanciers = (payload: FilterMetadata): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIERS,
    payload: payload
});

export const createCoLenderFinancier = (payload: CoLenderFinancier): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.CREATE_CO_LENDER_FINANCIER,
    payload: payload,
});

export const fetchCoLenderFinancierById = (payload: any): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_BY_ID,
    payload: payload,
});

export const updateCoLenderFinancier = (payload: CoLenderFinancier): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.UPDATE_CO_LENDER_FINANCIER,
    payload: payload,
});

export const deleteCoLenderFinancier = (payload: any): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.DELETE_CO_LENDER_FINANCIER,
    payload: payload,
});

export const resetCoLenderFinancier = (): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.RESET_CO_LENDER_FINANCIER,
    payload: {},
});

export const fetchCoLenderFinancierVersions = (payload: any): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS,
    payload: payload,
});

export const fetchCoLenderFinancierVersionDetails= (payload: any): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_VERSIONS_DETAILS,
    payload: payload,
});
export const fetchCoLenderFinancierLatestVersion = (payload: any): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.FETCH_CO_LENDER_FINANCIER_LATEST_VERSIONS,
    payload: payload,
});

export const blockCoLenderFinancier = (payload: any): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.BLOCK_CO_LENDER_FINANCIER,
    payload: payload,
});
export const approveCoLenderFinancier = (payload: any): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.APPROVE_CO_LENDER_FINANCIER,
    payload: payload,
});
export const rejectCoLenderFinancier = (payload: any): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.REJECT_CO_LENDER_FINANCIER,
    payload: payload,
});
export const freezeCoLenderFinancier = (payload: any): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.FREEZE_CO_LENDER_FINANCIER,
    payload: payload,
});
export const unfreezeCoLenderFinancier = (payload: any): CoLenderFinancierActionDispatch => ({
    type: CoLenderFinancierReduxTypes.UNFREEZE_CO_LENDER_FINANCIER,
    payload: payload,
});


